import { PayloadAction } from 'typesafe-actions';
import { TransactionsActionTypes, TransactionsProviderState } from './types';

const TransactionsReducer = (
  state: TransactionsProviderState,
  action: PayloadAction<TransactionsActionTypes, any>,
): TransactionsProviderState => {
  switch (action.type) {
    case TransactionsActionTypes.setSelectedTransaction:
      return { ...state, selectedTransaction: action.payload };
    default: {
      return state;
    }
  }
};

export { TransactionsReducer };
